<div class="file-manager"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">

    <!-- Toolbar -->
    <div class="fm-toolbar">
        <div class="fm-toolbar__left">
            <button pButton pRipple icon="pi pi-upload" label="Upload" class="p-button-sm" (click)="triggerUpload()"></button>
        </div>
        <div class="fm-toolbar__right">
            <span class="fm-toolbar__count" *ngIf="!loading">{{ userFiles.length }} file(s)</span>
        </div>
    </div>

    <!-- Drag overlay -->
    <div class="fm-drop-overlay" *ngIf="isDragging">
        <div class="fm-drop-overlay__content">
            <i class="pi pi-cloud-upload"></i>
            <span>Drop file here to upload</span>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="fm-loading">
        <div *ngFor="let _ of [1,2,3,4]" class="fm-file-skeleton">
            <p-skeleton width="2rem" height="2rem" borderRadius="6px"></p-skeleton>
            <div class="fm-file-skeleton__text">
                <p-skeleton width="60%"></p-skeleton>
                <p-skeleton width="30%" height="0.7rem"></p-skeleton>
            </div>
            <p-skeleton width="4rem" height="1.5rem" borderRadius="4px"></p-skeleton>
        </div>
    </div>

    <!-- File List -->
    <div *ngIf="!loading && userFiles.length" class="fm-file-list">
        <div *ngFor="let file of userFiles" class="fm-file" (dblclick)="openFile(file)">
            <div class="fm-file__icon" [ngClass]="getFileIconClass(file.name)">
                <i [class]="getFileIcon(file.name)"></i>
            </div>
            <div class="fm-file__info">
                <div class="fm-file__name" [pTooltip]="file.name" tooltipPosition="top">{{ file.name }}</div>
                <div class="fm-file__date">{{ file.createdDate | utcToLocal: 'MM-DD-YYYY h:mm A' }}</div>
            </div>
            <div class="fm-file__actions">
                <button pButton pRipple icon="pi pi-eye" class="p-button-text p-button-sm p-button-rounded" pTooltip="Open" tooltipPosition="top" (click)="openFile(file)"></button>
                <button pButton pRipple icon="pi pi-download" class="p-button-text p-button-sm p-button-rounded" pTooltip="Download" tooltipPosition="top" (click)="downloadFile(file)"></button>
                <button pButton pRipple icon="pi pi-trash" class="p-button-text p-button-sm p-button-rounded p-button-danger" pTooltip="Delete" tooltipPosition="top" (click)="confirmDelete(file)"></button>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !userFiles.length" class="fm-empty">
        <i class="pi pi-folder-open"></i>
        <p>No files yet</p>
        <button pButton pRipple icon="pi pi-upload" label="Upload a file" class="p-button-outlined p-button-sm" (click)="triggerUpload()"></button>
    </div>
</div>

<!-- Upload Dialog -->
<p-dialog styleClass="dark-glass-dialog" header="Upload File" appendTo="body" (onHide)="cancel()" [(visible)]="showModal" [modal]="true" [style]="{ width: '480px' }" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <form (ngSubmit)="(f.form.valid)" #f="ngForm" novalidate>
        <div class="fm-upload-form">
            <div class="fm-upload-form__field">
                <label>File Name <span class="text-danger">*</span></label>
                <input type="text" name="name" [(ngModel)]="selectedRow.name" #name="ngModel" class="form-control form-control-lg form-control-solid" maxlength="50" required placeholder="Enter a name for this file" />
            </div>
            <div class="fm-upload-form__field">
                <label>File</label>
                <div class="fm-upload-form__dropzone" (click)="fileInput.click()" [class.fm-upload-form__dropzone--has-file]="fileName">
                    <input #fileInput type="file" name="filePath" [(ngModel)]="selectedRow.filePath" #filePath="ngModel" (change)="fileUploadChange($event)" required hidden />
                    <div *ngIf="!fileName" class="fm-upload-form__dropzone-content">
                        <i class="pi pi-cloud-upload"></i>
                        <span>Click to select a file</span>
                    </div>
                    <div *ngIf="fileName" class="fm-upload-form__dropzone-file">
                        <i class="pi pi-file"></i>
                        <span>{{ fileName }}</span>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text text-secondary" (click)="cancel()"></button>
        <button pButton pRipple [disabled]="!f.valid || showLoader" [loading]="showLoader" label="Upload" icon="pi pi-upload" (click)="createAndUpdateFile()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog styleClass="dark-glass-dialog" appendTo="body" [style]="{ width: '450px' }" key="userFileDelele" [baseZIndex]="10000"></p-confirmDialog>
